<div class="left" longPress shortPress (shortPress)="leftSide()" (mouseLongPress)="onLongGesture()"></div>
<div class="right" longPress shortPress (shortPress)="rightSide()" (mouseLongPress)="onLongGesture()"></div>
